export const ORGANIZATION_SETTINGS_WIDGETS_KEY = 'widgets'
